import { PageHeader } from '../components/PageHeader';
import { ScoreBadge } from '../components/ScoreBadge';
import { orchestrationScores } from '../lib/seedData';

export function RankingPage() {
  const ranked = [...orchestrationScores].sort((a, b) => b.score - a.score);

  return (
    <section className="page">
      <PageHeader title="Ranking page" description="Sorted combinations by weighted reliability, fit, compatibility, cost, and evidence quality." />
      <div className="grid">
        {ranked.map((score, index) => (
          <article className="card metric" key={score.id}>
            <span>#{index + 1} {score.taskTypeId}</span>
            <ScoreBadge score={score.score} />
          </article>
        ))}
      </div>
    </section>
  );
}
